/*
 * Copyright (c) 2022.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface SystemTag {
  id: number;
  header: string;
  icon: string;
  color?: string;
  enabled: boolean;
  deleted?: boolean;
}
